export default __webpack_public_path__ + "img/play-button.da332239.svg";